// VliidatedImage.jsx
// Component that provides a validated image component.
// The component is only rendered if the image is valid.

// Copyright HS Analysis GmbH, 2025
// Author: Viktor Eberhardt

// Framework imports
import React from "react";
import PropTypes from "prop-types";

const ValidatedImage = ({ src, alt, setIsValid, ...rest }) => {
  const [isImageValid, setIsImageValid] = React.useState(false);

  /**
   * Updates the image validity state and optionally notifies a parent component.
   *
   * @param {boolean} isValid - Indicates whether the image is valid.
   */
  const updateIsValid = (isValid) => {
    setIsImageValid(isValid);
    if (setIsValid) {
      setIsValid(isValid);
    }
  };

  React.useEffect(() => {
    if (!src) return;
    let isMounted = true;
    const img = new window.Image();
    img.onload = () => {
      if (isMounted) updateIsValid(true);
    };
    img.onerror = () => {
      if (isMounted) updateIsValid(false);
    };
    img.src = src;
    return () => {
      isMounted = false;
    };
  }, [src]);

  if (!isImageValid) return null;

  return <img src={src} alt={alt} {...rest} />;
};

ValidatedImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  setIsValid: PropTypes.func,
};

export default ValidatedImage;
